import { COLORS, defaultFontSizePx, TEXT_TAB_SIZE_MOD } from '../constants';
import { isVisibleWordType, v2 } from '../helpers';
import { startAutoTypeController } from './textobject';
import {
  TextAppearStyle,
  WordType,
  type Color,
  type TextObject,
  type Word,
  type WordStyle,
} from '../types';
import * as TextLayoutController from '../controllers/text_layout_controller';

export function parseText(tObj: TextObject, text: string, isVisibleText = false): Word[] {
  let wordCharArray: string[] = [];
  let sentenceStart = 0;
  let alineaStart = 0;
  let tagStart = -1;
  const manager = tObj.manager;

  const fontSizePx = tObj.textStyle.doAutoResize
    ? tObj.textStyle.fontSizeEm * manager.rootFontSizePx
    : tObj.textStyle.fontSizeEm * defaultFontSizePx;
  tObj.fontSizePx = fontSizePx;
  const ctx = tObj.manager.textRenderCtx;

  const words = [];

  words.push(getWordOfType(WordType.AlineaStart));

  words.push(getWordOfType(WordType.SentenceStart));

  let currentWordStyle: WordStyle = {
    color: tObj.textStyle.color,
    defaultTextColor: null,
    fontSizeEm: tObj.textStyle.fontSizeEm,
    fontSizePx: fontSizePx,
    fontId: tObj.textStyle.fontId,
  };
  let wordStyles = [currentWordStyle];

  tObj.text = text || '';

  if (text) {
    for (let i = 0; i < text.length; i++) {
      const char: string = text.charAt(i);
      // const isEndOfWord = i === text.length - 1 || text.charAt(i - 1) === ' ';
      // const ascii = text.charCodeAt(i);

      if (char != ' ' && alineaStart < 0) {
        alineaStart = i;
        const word = getWordOfType(WordType.AlineaStart);
        words.push(word);
        wordCharArray = [];
      }

      if (char != ' ' && sentenceStart < 0 && char != '\n' && char != '\r') {
        sentenceStart = i;
        const word = getWordOfType(WordType.SentenceStart);
        words.push(word);
        wordCharArray = [];
      }

      if (char == ' ') {
        if (wordCharArray.length > 0) {
          let newWord = createWord(
            ctx,
            wordCharArray,
            WordType.Word,
            fontSizePx,
            null,
            isVisibleText,
            currentWordStyle,
          );

          words.push(newWord);

          wordCharArray = [];
        }
        wordCharArray.push(char);
        let newWord = createWord(
          ctx,
          wordCharArray,
          WordType.Space,
          fontSizePx,
          null,
          isVisibleText,
          currentWordStyle,
        );

        words.push(newWord);
        wordCharArray = [];
      } else if (char == '\n' || char == '\r') {
        if (wordCharArray.length > 0) {
          let newWord = createWord(
            ctx,
            wordCharArray,
            WordType.Word,
            fontSizePx,
            null,
            isVisibleText,
            currentWordStyle,
          );

          words.push(newWord);
        }

        if (sentenceStart >= 0) {
          words.push(getWordOfType(WordType.SentenceEnd));
          sentenceStart = -1;
        }

        //add alinea end mark
        words.push(getWordOfType(WordType.AlineaEnd));
        wordCharArray = [];
        alineaStart = -1;
      } else if (char == '<') {
        tagStart = i;
        if (wordCharArray.length > 0) {
          let newWord = createWord(
            ctx,
            wordCharArray,
            WordType.Word,
            fontSizePx,
            null,
            isVisibleText,
            currentWordStyle,
          );

          words.push(newWord);
          wordCharArray = [];
        }
        wordCharArray.push(char);
      } else if (char == '>') {
        if (tagStart >= 0) {
          wordCharArray.push(char);
          if (wordCharArray.length > 0) {
            let newWord = createTagWord(
              ctx,
              wordCharArray,
              fontSizePx,
              null,
              isVisibleText,
              currentWordStyle,
              tObj.manager.user.slug,
            );
            if (!newWord) {
              newWord = createWord(
                ctx,
                wordCharArray,
                WordType.Word,
                fontSizePx,
                null,
                isVisibleText,
                currentWordStyle,
              );
            } else {
              if (newWord.type === WordType.StyleTag) {
                if (wordCharArray[1] === '/') {
                  if (wordStyles.length > 1) {
                    wordStyles.length = wordStyles.length - 1;
                    currentWordStyle = wordStyles[wordStyles.length - 1];
                  }
                } else {
                  wordStyles.push(newWord.wordStyle);
                  currentWordStyle = newWord.wordStyle;
                }
              }
            }

            if (newWord.type === WordType.ListItemStart) {
              if (sentenceStart >= 0 && sentenceStart !== i - 3) {
                const sEnd = createWord(
                  ctx,
                  [],
                  WordType.SentenceEnd,
                  fontSizePx,
                  null,
                  true,
                  newWord.wordStyle,
                );
                words.push(sEnd);
                sentenceStart = -1;
              }
              if (alineaStart >= 0 && alineaStart !== i - 3) {
                const aEnd = createWord(
                  ctx,
                  [],
                  WordType.AlineaEnd,
                  fontSizePx,
                  null,
                  true,
                  newWord.wordStyle,
                );

                const aStart = createWord(
                  ctx,
                  [],
                  WordType.AlineaStart,
                  fontSizePx,
                  null,
                  true,
                  newWord.wordStyle,
                );

                words.push(aEnd);
                words.push(aStart);
                alineaStart = i;
              }
            }

            words.push(newWord);

            if (newWord.type === WordType.ListItemEnd) {
              const aEnd = createWord(
                ctx,
                [],
                WordType.AlineaEnd,
                fontSizePx,
                null,
                true,
                newWord.wordStyle,
              );
              words.push(aEnd);
            }

            wordCharArray = [];
          }
        } else {
          wordCharArray.push(char);
          if (wordCharArray.length === 0) {
          }
        }
      } else {
        wordCharArray.push(char);
      }
    }
  }
  if (wordCharArray.length > 0) {
    let newWord = createWord(
      ctx,
      wordCharArray,
      WordType.Word,
      fontSizePx,
      null,
      isVisibleText,
      currentWordStyle,
    );

    words.push(newWord);
    wordCharArray = [];
  }
  {
    let newWord = createWord(
      ctx,
      [],
      WordType.SentenceEnd,
      fontSizePx,
      null,
      isVisibleText,
      currentWordStyle,
    );
    words.push(newWord);
  }
  {
    let newWord = createWord(
      ctx,
      [],
      WordType.AlineaEnd,
      fontSizePx,
      null,
      isVisibleText,
      currentWordStyle,
    );
    words.push(newWord);
  }

  return words;
}

export function createWord(
  ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D,
  chars: string[],
  wordType: WordType,
  fontSizePx: number,
  textColor: Color | null, //when null, default text color of textobject is used
  isVisibleText = true,
  wordStyle: WordStyle,
): Word {
  let newWord: Word = getWordOfType(wordType);

  if (isVisibleWordType(wordType)) {
    newWord.text = chars.join('');
    if (isVisibleText) {
      newWord.visibleText = newWord.text;
    }

    newWord.width = TextLayoutController.getTextWidth(
      ctx,
      wordStyle.fontId,
      fontSizePx,
      newWord.text,
    );

    if (wordType === WordType.Space) {
      newWord.width *= 1;
    }
    newWord.height = fontSizePx;
    newWord.textColor = textColor;
    newWord.wordStyle = { ...wordStyle };
  } else if (wordType === WordType.StyleTag) {
    if (wordStyle?.fontId === 'font_regular') {
      newWord.wordStyle = {
        ...wordStyle,
        fontId: 'font_bold',
      };
    } else if (wordStyle?.fontId === 'font_bold') {
      newWord.wordStyle = {
        ...wordStyle,
        fontId: 'font_extrabold',
      };
    } else {
      newWord.wordStyle = {
        ...wordStyle,
      };
    }
  }

  return newWord;
}

function createTagWord(
  ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D,
  chars: string[],
  fontSizePx: number,
  textColor: Color | null, //when null, default text color of textobject is used
  isVisibleText = true,
  wordStyle: WordStyle,
  myClientSlug: string,
): Word {
  let text = chars.join('');
  let isMe = false;

  if (text.substring(0, 5) === '<name') {
    const clientId = text.substring(5, text.length - 1);
    isMe = clientId === myClientSlug;
    if (isMe) {
      text = '<me>';
    } else {
      text = '<name>';
    }
  } else if (text.substring(0, 6) === '</name') {
    const clientId = text.substring(6, text.length - 1);
    isMe = clientId === myClientSlug;
    if (isMe) {
      text = '<me>';
    } else {
      text = '<name>';
    }
  }

  let newWord: Word;

  switch (text) {
    case '<b>':
      {
        newWord = getWordOfType(WordType.StyleTag);
        if (wordStyle?.fontId === 'font_regular') {
          newWord.wordStyle = {
            ...wordStyle,
            fontId: 'font_bold',
          };
        } else if (wordStyle?.fontId === 'font_bold') {
          newWord.wordStyle = {
            ...wordStyle,
            fontId: 'font_extrabold',
          };
        } else {
          newWord.wordStyle = {
            ...wordStyle,
          };
        }
      }
      break;
    case '</b>':
      {
        newWord = getWordOfType(WordType.StyleTag);
        newWord.wordStyle = {
          ...wordStyle,
        };
      }
      break;
    case '<me>':
      {
        newWord = getWordOfType(WordType.StyleTag);

        newWord.wordStyle = {
          ...wordStyle,
          defaultTextColor: COLORS.NEW_STYLE.BLUE_LIGHT,
        };
      }
      break;
    case '</me>':
      {
        newWord = getWordOfType(WordType.StyleTag);
        newWord.wordStyle = {
          ...wordStyle,
        };
      }
      break;
    case '<name>':
      {
        newWord = getWordOfType(WordType.StyleTag);

        newWord.wordStyle = {
          ...wordStyle,
        };
      }
      break;
    case '</name>':
      {
        newWord = getWordOfType(WordType.StyleTag);
        newWord.wordStyle = {
          ...wordStyle,
        };
      }
      break;
    case '<li>':
      {
        newWord = getWordOfType(WordType.ListItemStart);
        newWord.wordStyle = {
          ...wordStyle,
        };
        newWord.height = fontSizePx;
        newWord.width = fontSizePx * TEXT_TAB_SIZE_MOD;
        newWord.text = '*';
        if (isVisibleText) {
          newWord.visibleText = '*';
        }
      }
      break;
    case '<anchor>':
      {
        newWord = getWordOfType(WordType.Anchor);
        newWord.wordStyle = {
          ...wordStyle,
        };
        newWord.height = fontSizePx;
        newWord.width = TextLayoutController.getTextWidth(ctx, wordStyle.fontId, fontSizePx, 'O');
        newWord.text = '*';
        if (isVisibleText) {
          newWord.visibleText = '*';
        }
      }
      break;
    case '</li>':
      {
        newWord = getWordOfType(WordType.ListItemEnd);
        newWord.wordStyle = {
          ...wordStyle,
        };
      }
      break;
    default:
      console.warn('which tag type is this?', chars, text);
      return null;
  }

  return newWord;
}

function getWordOfType(type: WordType): Word {
  let word = getZeroWord();
  word.type = type;
  return word;
}

function getZeroWord(): Word {
  return {
    type: WordType.none,
    text: '',
    visibleText: '',
    localPos: v2(),
    pos: v2(),
    offset: v2(),
    width: 0,
    height: 0,
    textColor: null,
    colorAlpha: 255,
    wordStyle: null,
    clickActionId: '',
    hover: false,
    command: null,
  };
}
